import { useState } from 'react'
import { useStyles } from './ColumnReadMore.styles'
import { textOverFlowSpace } from './textOverFlowSpace'

export const ColumnReadMore = ({
  description,
  initializeWithLowerCase = false,
  customCharForRemoveFromMax,
}: {
  description: string
  initializeWithLowerCase?: boolean
  customCharForRemoveFromMax?: number
}) => {
  const { classes } = useStyles()
  const [expanded, setExpanded] = useState<boolean>(false)
  const { isTextLengthBig, truncateDescription, descriptionRef } =
    textOverFlowSpace({
      customCharForRemoveFromMax: customCharForRemoveFromMax ?? 2,
      description,
    })

  const toggleDescription = () => {
    setExpanded(!expanded)
  }
  const readmoreText = `${initializeWithLowerCase ? 'r' : 'R'}ead more`
  const readlessText = `${initializeWithLowerCase ? 'r' : 'R'}ead less`
  return (
    <div ref={descriptionRef} className={classes.root}>
      {expanded ? description : truncateDescription(description)}

      {isTextLengthBig && (
        <span
          className={classes.link}
          data-testid={'action-link'}
          onClick={() => toggleDescription()}
        >
          {expanded ? readlessText : readmoreText}
        </span>
      )}
    </div>
  )
}
